import * as React from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions/useWindowDimensions';

import { SCREEN_NORMAL, SCREEN_TABLET } from '../../config/constants';
// import SkeletonWrapper from '../../../../shared/components/SkeletonWrapper';
import { ReactComponent as OverviewSkeletonMobile } from '../../assets/loaders/overview-skeleton-mobile.svg';
import { ReactComponent as OverviewSkeletonTablet } from '../../assets/loaders/overview-skeleton-tablet.svg';
import { ReactComponent as OverviewSkeletonDesktop } from '../../assets/loaders/overview-skeleton-desktop.svg';
import { ReactComponent as MyContractSkeletonMobile } from '../../assets/loaders/my-contract-skeleton-mobile.svg';
import { ReactComponent as MyContractSkeletonTablet } from '../../assets/loaders/my-contract-skeleton-tablet.svg';
import { ReactComponent as MyContractSkeletonDesktop } from '../../assets/loaders/my-contract-skeleton-desktop.svg';
import { ReactComponent as MeterReadingsSkeletonMobile } from '../../assets/loaders/usage-skeleton-mobile.svg';
import { ReactComponent as MeterReadingsSkeletonTablet } from '../../assets/loaders/usage-skeleton-tablet.svg';
import { ReactComponent as MeterReadingsSkeletonDesktop } from '../../assets/loaders/usage-skeleton-desktop.svg';
import { ReactComponent as InvoicesSkeletonMobile } from '../../assets/loaders/invoices-skeleton-mobile.svg';
import { ReactComponent as InvoicesSkeletonTablet } from '../../assets/loaders/invoices-skeleton-tablet.svg';
import { ReactComponent as InvoicesSkeletonDesktop } from '../../assets/loaders/invoices-skeleton-desktop.svg';
import { ReactComponent as DefaultSkeletonMobile } from '../../assets/loaders/default-skeleton-mobile.svg';
import { ReactComponent as DefaultSkeletonTablet } from '../../assets/loaders/default-skeleton-tablet.svg';
import { ReactComponent as DefaultSkeletonDesktopSingleColumn } from '../../assets/loaders/default-skeleton-desktop-single-column.svg';
import { ReactComponent as DefaultSkeletonDesktopTwoColumn } from '../../assets/loaders/default-skeleton-desktop-two-column.svg';


interface Props {
  type: 'overview' | 'usage' | 'invoices' | 'my-contract' | 'general';
  twoColumnLayout?: boolean;
}

const SkeletonLoader: React.FC<Props> = ({ type, twoColumnLayout = false }) => {
  const { width } = useWindowDimensions();

  const isDesktop = width >= SCREEN_NORMAL;
  const isTablet = width >= SCREEN_TABLET;
  const isMobile = width < SCREEN_TABLET;

  const renderSkeletonLoader = () => {
    if (type === 'overview' && isDesktop) return <OverviewSkeletonDesktop />;

    if (type === 'overview' && isTablet) return <OverviewSkeletonTablet />;

    if (type === 'overview' && isMobile) return <OverviewSkeletonMobile />;

    if (type === 'usage' && isDesktop) return <MeterReadingsSkeletonDesktop />;

    if (type === 'usage' && isTablet) return <MeterReadingsSkeletonTablet />;

    if (type === 'usage' && isMobile) return <MeterReadingsSkeletonMobile />;

    if (type === 'invoices' && isDesktop) return <InvoicesSkeletonDesktop />;

    if (type === 'invoices' && isTablet) return <InvoicesSkeletonTablet />;

    if (type === 'invoices' && isMobile) return <InvoicesSkeletonMobile />;

    if (type === 'my-contract' && isDesktop) return <MyContractSkeletonDesktop />;

    if (type === 'my-contract' && isTablet) return <MyContractSkeletonTablet />;

    if (type === 'my-contract' && isMobile) return <MyContractSkeletonMobile />;

    if (type === 'general' && isDesktop) return <DefaultSkeletonDesktopSingleColumn />;

    if (twoColumnLayout && isDesktop) return <DefaultSkeletonDesktopTwoColumn />;

    if (type === 'general' && isTablet) return <DefaultSkeletonTablet />;

    if (type === 'general' && isMobile) return <DefaultSkeletonMobile />;

    // return the default mobile skeleton loader as fallback
    return <DefaultSkeletonMobile />;
  };

  return (

    <div className="skeleton-loader">
      {renderSkeletonLoader()}
    </div>

  );
};

export default SkeletonLoader;
